module.exports = __webpack_public_path__ + "img/921_page_image_paper.53e7fdf0.jpg";